import React from 'react';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { getDisplayHotelGuests } from '@airasia-common/libraries/i18n/LocaleHelper';
import styled from 'styled-components';
import {
  formatDisplayDay,
  formatTime,
  parseAPIDay,
  DATE_FORMAT_DEFAULT,
} from '@airasia-common/libraries/datetime';
import { object } from 'prop-types';

const SubInfo = styled.span(({ theme }) => ({
  marginRight: 16,
  color: theme.colors.greyDark,
}));

export const getTextsFromFilter = filter => {
  const checkinDate = filter.checkin && parseAPIDay(filter.checkin);
  const checkoutDate = filter.checkout && parseAPIDay(filter.checkout);
  const date =
    filter.checkin &&
    `${formatDisplayDay(checkinDate)} – ${formatDisplayDay(checkoutDate)}`;
  const guests = getDisplayHotelGuests(filter.guests);
  const rooms =
    filter.occupancy && translate('common.rooms', filter.occupancy.length);

  return {
    date,
    guests,
    rooms,
    checkin: formatTime(checkinDate, DATE_FORMAT_DEFAULT),
    checkout: formatTime(checkoutDate, DATE_FORMAT_DEFAULT),
  };
};

export const StyledHeaderSubTitle = ({ filter }) => {
  const { date, guests, rooms } = getTextsFromFilter(filter);

  return (
    <>
      <SubInfo>{date}</SubInfo>
      <SubInfo>{guests}</SubInfo>
      <SubInfo>{rooms}</SubInfo>
    </>
  );
};

StyledHeaderSubTitle.propTypes = {
  filter: object,
};
